import React from 'react';

// Internal Import
import { AppBarComponent } from '../components/appbar';
import { FooterComponent } from '../components/footer';

// External Import
import { common } from "@mui/material/colors";
import { useNavigate, useParams } from 'react-router-dom';


import {
    Box,
    Grid,
    Stack,
    Button,
    Typography,
} from '@mui/material';


const dataDetailDefault = {
    name: 'cluster varrena',
    priceMin: '500000000',
    proyek: {
        name: 'citraraya tangerang',
        logo: 'https://www.google.com/url?sa=i&url=https%3A%2F%2Fwww.citramajaraya.co%2F&psig=AOvVaw1JorqcysRrHq9YTzHnE2Mi&ust=1692149352309000&source=images&cd=vfe&opi=89978449&ved=0CBAQjRxqFwoTCPiXidrB3YADFQAAAAAdAAAAABAE',
    },
    vt: [
        {
            id: 1,
            img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',
            url: 'https://citramaja.com/360/citralink/agate/E/'
        },
        {
            id: 2,
            img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62',
            url: 'https://citramaja.com/360/tampaksiring/freesia/'
        },
        {
            id: 3,
            img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',
            url: 'https://citramaja.com/360/tampaksiring/gardenia/'
        },
    ],
    spesifikasi: "<h3><b>Cluster Varenna terdiri dari 3 tipe:</b></h3> <br /> <b>Tipe Fitto</b> <p>Luas tanah 60m2 (5×12) dan 75m2 (5×15)</p> <p>Luas bangunan 34m2</p> <br /> <b>Tipe Grosso</b> <p>Luas  tanah 72m2 (6×12)</p> <p>Luas bangunan 37m2</p> <br /> <b>Tipe Lusso</b> <p>Luas tanah 84m2 (7×12) dan 105m2 (7×15)</p> <p>Luas bangunan 46m2</p>",
    desc: '<p>Produk perumahan terbaru dari Ciputra Group yang mengusung semangat #MimpiJadiNyata karena bisa didapatkan dengan harga perdana Rp595 juta. Berada di kawasan berskala kota dengan fasilitas lengkap menjadikan Varena tempat yang nyaman sebagai hunian bagi keluarga</p> <br /> <p>Fasilitas di sekitar Varenna: Mal Ciputra Tangerang, Kampus dan Sekolah, Ciputra Hospital, Office & Bank, Trans CitraRaya, Shopping Center, Ciputra Food Festival, City Market, Water Park, Theme Park.</p>',
    contact: '<br /> <p>Hubungi tim marketing CitraRaya sekarang juga untuk mendapatkan penawaran terbaik untuk Varenna</p> <br /> <p><b>(021)5960888</b></p>',
    image: [
        {
            id: 1,
            img: require('./../asset/Varrena.jpg')
        },
        {
            id: 2,
            img: require('./../asset/Varrena-i1.jpeg')
        },
        {
            id: 3,
            img: require('./../asset/Varrena-i2.jpg')
        },
        {
            id: 4,
            img: require('./../asset/Varrena-i3.jpg')
        },
        {
            id: 5,
            img: require('./../asset/Varrena-i4.jpg')
        },
    ]
};

const dataTabs = ['description', 'spesification', 'contact us'];


export interface DetailProductProps { }
export const DetailProductScreen: React.FC<DetailProductProps> = () => {

    let navigate = useNavigate();

    let { id } = useParams();

    const [activeTab, setActiveTab] = React.useState<number>(0);

    return (
        <Stack>
            <AppBarComponent />


            <Stack sx={{ mt: 4 }}>
                <Box sx={{
                    width: '92%',
                    marginTop: 3,
                    objectFit: 'cover',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                }}>
                    <Typography
                        color={common.black}
                        sx={{
                            fontWeight: '700',
                            fontFamily: 'Roboto',
                            textTransform: 'capitalize',
                            fontSize: { xs: '0.8', sm: '1.2em', md: '1.6em' },
                        }}
                    >{dataDetailDefault.name}</Typography>
                </Box>

                <Box sx={{
                    width: '92%',
                    marginTop: 2,
                    marginBottom: 2,
                    display: 'flex',
                    objectFit: 'cover',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                }}>
                    <Box sx={{
                        width: "58%",
                        height: "24em",
                        display: 'flex',
                        borderRadius: '1.5em',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundImage: `url(${dataDetailDefault.image[0].img})`,
                        boxShadow: 'rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px'
                    }} />

                    <Box sx={{
                        width: "39%",
                        height: "24em",
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-around',
                    }}>
                        <Box sx={{
                            flex: 1,
                            width: '100%',
                            display: 'flex',
                            height: '11.75em',
                            flexDirection: 'row',
                            borderRadius: '1.25em',
                        }}>
                            <Box sx={{
                                mr: 1,
                                mb: 0.5,
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'row',
                                borderRadius: '1.25em',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                backgroundImage: `url(${dataDetailDefault.image[1].img})`,
                                boxShadow: 'rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px'
                            }} />
                            <Box sx={{
                                mr: 1,
                                mb: 0.5,
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'row',
                                borderRadius: '1.25em',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                backgroundImage: `url(${dataDetailDefault.image[2].img})`,
                                boxShadow: 'rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px'
                            }} />
                        </Box>

                        <Box sx={{
                            flex: 1,
                            width: '100%',
                            display: 'flex',
                            height: '11.5em',
                            flexDirection: 'row',
                            borderRadius: '1.25em',
                        }}>
                            <Box sx={{
                                mr: 1,
                                mt: 0.5,
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'row',
                                borderRadius: '1.25em',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                backgroundImage: `url(${dataDetailDefault.image[3].img})`,
                                boxShadow: 'rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px'
                            }} />
                            <Box sx={{
                                mr: 1,
                                mt: 0.5,
                                flex: 1,
                                display: 'flex',
                                flexDirection: 'row',
                                borderRadius: '1.25em',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                backgroundImage: `url(${dataDetailDefault.image[4].img})`,
                                boxShadow: 'rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px'
                            }} />
                        </Box>
                    </Box>
                </Box>

                {/* // Table Desc // */}
                <Stack>
                    <Box sx={{
                        mt: '2em',
                        width: '78%',
                        display: 'flex',
                        objectFit: 'cover',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                    }}>
                        {dataTabs.map((item: string, index: number) => {
                            return (
                                <Button
                                    size='small'
                                    variant='contained'
                                    onClick={() => setActiveTab(index)}
                                    sx={{
                                        margin: 0.5,
                                        color: common.white,
                                        textTransform: 'capitalize',
                                    }}
                                > {item}</Button>
                            )
                        })}
                    </Box>
                    <Grid container spacing={2} sx={{
                        width: '88%',
                        mb: 10,
                        display: 'flex',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        flexDirection: 'row',
                    }}>
                        <Grid item xs={12} xl={12} sx={{
                            pb: 5,
                            borderRadius: '0.8em',
                            backgroundColor: 'rgba(246, 246, 246, 1)',
                            boxShadow: 'rgba(0, 0, 0, 0.15) 0px 5px 15px 0px'
                        }}>
                            {activeTab == 0 && (
                                <>
                                    <br />
                                    <br />
                                    <Typography
                                        color={common.black}
                                        sx={{
                                            mb: 1,
                                            fontWeight: 'bold',
                                            fontFamily: 'Roboto',
                                            textTransform: 'capitalize',
                                            fontSize: { xs: '0.8em', sm: '1em', md: '1.2em' },
                                        }}
                                    >{dataDetailDefault.name}</Typography>
                                    <div dangerouslySetInnerHTML={{__html: dataDetailDefault.desc}}></div>
                                </>
                            )}
                            {activeTab == 1 && (
                                <>
                                    <br />
                                    <br />
                                    <div dangerouslySetInnerHTML={{__html: dataDetailDefault.spesifikasi}}></div>
                                </>
                            )}

                            
                            {activeTab == 2 && (
                                <>
                                    <br />
                                    <br />
                                    {/* <Typography
                                        color={common.black}
                                        sx={{
                                            mb: 1,
                                            fontWeight: 'bold',
                                            fontFamily: 'Roboto',
                                            textTransform: 'capitalize',
                                            fontSize: { xs: '0.8em', sm: '1em', md: '1.2em' },
                                        }}
                                    >{dataDetailDefault.name}</Typography> */}
                                    <div dangerouslySetInnerHTML={{__html: dataDetailDefault.contact}}></div>
                                </>
                            )}
                            
                        </Grid>
                    </Grid>
                </Stack>
            </Stack>

            {/* // Footer // */}
            <FooterComponent />

        </Stack>
    )
};